import { Link as RouterLink } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import gcasLogo from "../assets/images/gcas-logo.svg";

function Footer() {
	const year = new Date().getFullYear();

	return (
		<footer className="siteFooter">
			<div className="siteFooterTop">
				<div className="siteFooterBrand">
					<RouterLink className="siteFooterLogo" to="/">
						<img alt="GCAS Regina" src={gcasLogo} />
					</RouterLink>
					<p className="siteFooterTagline">
						Uniting Ghanaians and Canadians across Saskatchewan.
					</p>
					<div className="siteFooterSocials">
						<a
							href="https://www.instagram.com/yourprofile"
							target="_blank"
							rel="noopener noreferrer"
							aria-label="Visit our Instagram profile"
						>
							<i className="fa-brands fa-instagram"></i>
						</a>
						<a
							href="https://wa.me/yourphonenumber"
							target="_blank"
							rel="noopener noreferrer"
							aria-label="Chat with us on WhatsApp"
						>
							<i className="fa-brands fa-whatsapp"></i>
						</a>
						<a
							href="https://www.facebook.com/yourpage"
							target="_blank"
							rel="noopener noreferrer"
							aria-label="Visit our Facebook page"
						>
							<i className="fa-brands fa-facebook"></i>
						</a>
					</div>
				</div>

				<nav className="siteFooterNav" aria-label="Footer">
					<div className="siteFooterNavCol">
						<span className="siteFooterNavHeading">Explore</span>
						<RouterLink to="/">Home</RouterLink>
						<RouterLink to="/events">Events</RouterLink>
						<ScrollLink
							spy={true}
							smooth={true}
							offset={-100}
							duration={500}
							href="/"
							to="about"
						>
							About Us
						</ScrollLink>
						<ScrollLink
							spy={true}
							smooth={true}
							offset={-100}
							duration={500}
							href="/"
							to="contact"
						>
							Contact Us
						</ScrollLink>
					</div>

					<div className="siteFooterNavCol">
						<span className="siteFooterNavHeading">Get in Touch</span>
						<a href="mailto:info.gcasregina@gmail.com">
							info.gcasregina@gmail.com
						</a>
						<a href="tel:+13065022466">+1 (306) 502 2466</a>
					</div>

					<div className="siteFooterNavCol">
						<span className="siteFooterNavHeading">Legal</span>
						<RouterLink to="/privacy-policy">Privacy Policy</RouterLink>
						<RouterLink to="/terms-and-conditions">
							Terms and Conditions
						</RouterLink>
					</div>
				</nav>
			</div>

			<div className="siteFooterBottom">
				<p className="siteFooterCopyright">
					&copy; {year} GCAS Regina. All rights reserved.
				</p>
				<p className="siteFooterCredit">Built by Lacunity Studios</p>
			</div>
		</footer>
	);
}

export default Footer;
